import axios from './axiosInstance';
import { APISubscription, APIBillingPortalResponse } from '../../types';

interface SubscriptionParams {
  sport: string;
  resortId: string;
}

interface UpdatePaymentParams extends SubscriptionParams {
  paymentMethodId: string;
  agreedToTC: boolean;
}

interface RestrictReportsParams extends SubscriptionParams {
  role: string;
}

interface OpenBillingPortalParams {
  resortId: string;
}

const getSubscription = ({ sport, resortId }: SubscriptionParams): Promise<APISubscription> => {
  return axios.get(`${sport}/subscription/${resortId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const updatePayment = ({ sport, resortId, paymentMethodId, agreedToTC }: UpdatePaymentParams): Promise<APISubscription | void> => {
  return axios.post(`/${sport}/subscription/${resortId}`, {
    action: 'UPDATE_PAYMENT',
    paymentToken: paymentMethodId,
    agreedToTC,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const restrictFeatureReports = ({ sport, resortId, role }: RestrictReportsParams): Promise<APISubscription | void> => {
  return axios.post(`/${sport}/subscription/${resortId}`, {
    action: 'RESTRICT_FEATURE_REPORTS',
    role,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const restrictParkReports = ({ sport, resortId, role }: RestrictReportsParams): Promise<APISubscription | void> => {
  return axios.post(`/${sport}/subscription/${resortId}`, {
    action: 'RESTRICT_PARK_REPORTS',
    role,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const openBillingPortal = ({ resortId }: OpenBillingPortalParams): Promise<APIBillingPortalResponse> => {
  return axios.get(`/subscription/${resortId}/billingportal`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

const subscriptionFunctions = {
  getSubscription,
  updatePayment,
  restrictFeatureReports,
  restrictParkReports,
  openBillingPortal,
};

export default subscriptionFunctions;
